export default class PromotionCoupon {
	public text: string;
	public imageUrl: string;
}
